import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Returns true when the viewport is at or below the given MUI breakpoint.
 * Defaults to 'sm' (< 600px) which we treat as the phone breakpoint.
 * Use 'md' (< 900px) for phone + small tablet.
 */
const useIsMobile = (breakpoint: 'sm' | 'md' = 'sm'): boolean => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down(breakpoint));
};

export default useIsMobile;
